'use strict';

import dataStore from './dataStore';
import utils from './utils';

/**
 * vue-storeへのアクセスを伴うutil
 */
export default {
  getAllData: async (store, ga) => {
    // 思い出一覧の取得
    const res = await dataStore.getAllData(store.state.profile);
    const isValid = utils.parseAPIResponse(res);

    // ページリロードの時に取得したユーザデータをvue-storeに登録
    if (isValid) {
      store.commit('updateProfile', res.profile);
      store.commit('updatePartners', res.partners);
      store.commit('updateMemories', res.memories);
      store.commit('updateSelectUsers');
    }
    else {
      store.dispatch('showSnackbar', {
        ga: ga,
        snackbar: {
          color: 'error',
          text: 'データの取得に失敗しました',
          type: 'reload',
        },
      });
    }

  },
};